import pick from 'lodash/pick';
import { isErrorUserPendingApproval, isForbiddenError, storableError } from '../util/errors';
import { addMarketplaceEntities } from './marketplaceData.duck';

// ================ Action types ================ //
export const SET_INITIAL_VALUES = 'app/homepage/SET_INITIAL_VALUES';

export const GET_HOMEPAGE_CATEGORIES_REQUEST = 'app/homepage/GET_HOMEPAGE_CATEGORIES_REQUEST';
export const GET_HOMEPAGE_CATEGORIES_SUCCESS = 'app/homepage/GET_HOMEPAGE_CATEGORIES_SUCCESS';
export const GET_HOMEPAGE_CATEGORIES_ERROR = 'app/homepage/GET_HOMEPAGE_CATEGORIES_ERROR';

export const VISIT_HOMEPAGE_CATEGORIES_REQUEST = 'app/homepage/VISIT_HOMEPAGE_CATEGORIES_REQUEST';
export const VISIT_HOMEPAGE_CATEGORIES_SUCCESS = 'app/homepage/VISIT_HOMEPAGE_CATEGORIES_SUCCESS';
export const VISIT_HOMEPAGE_CATEGORIES_ERROR = 'app/homepage/VISIT_HOMEPAGE_CATEGORIES_ERROR';


export const SEARCH_LISTINGS_REQUEST = 'app/homepage/SEARCH_LISTINGS_REQUEST';
export const SEARCH_LISTINGS_SUCCESS = 'app/homepage/SEARCH_LISTINGS_SUCCESS';
export const SEARCH_LISTINGS_ERROR = 'app/homepage/SEARCH_LISTINGS_ERROR';
// ================ Reducer ================ //

const initialState = {
  categories: [],
  getCategoriesInProgress: null,
  getCategoriesMethodError: null,
  visitCategoriesInProgress: null,
  visitCategoriesMethodError: null,

  searchParams: null,
  searchInProgress: false,
  searchListingsError: null,
  currentPageResultIds: [],
  isTrainerSearch: false,
  isTraineeSearch: false,
};

const resultIds = data => {
  const listings = data.data;
  return listings
    .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
    .map(l => l.id);
};

export default function homepageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case GET_HOMEPAGE_CATEGORIES_REQUEST:
      return {
         ...state,
         getCategoriesInProgress: true,
         getCategoriesMethodError: false
       };
    case GET_HOMEPAGE_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesInProgress: false,
        categories: payload,
      };
    case GET_HOMEPAGE_CATEGORIES_ERROR:
      console.error(payload);
      return {
        ...state,
        getCategoriesInProgress: false,
        getCategoriesMethodError: payload,
      };

    case VISIT_HOMEPAGE_CATEGORIES_REQUEST:
      return {
         ...state,
         visitCategoriesInProgress: true,
         visitCategoriesMethodError: false
       };
    case VISIT_HOMEPAGE_CATEGORIES_SUCCESS:
      return {
        ...state,
        visitCategoriesInProgress: false,
      };
    case VISIT_HOMEPAGE_CATEGORIES_ERROR:
      console.error(payload);
      return {
        ...state,
        visitCategoriesInProgress: false,
        visitCategoriesMethodError: payload,
      };


    case SEARCH_LISTINGS_REQUEST:
      return {
        ...state,
        searchParams: payload.searchParams,
        searchInProgress: true,
        searchMapListingIds: [],
        searchListingsError: null,
        isTrainerSearch: payload?.params?.isTrainerSearch,
        isTraineeSearch: payload?.params?.isTraineeSearch,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
        isTrainerSearch: payload?.params?.isTrainerSearch,
        isTraineeSearch: payload?.params?.isTraineeSearch,
      };
    case SEARCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return {
        ...state,
        searchInProgress: false,
        searchListingsError: payload,
        isTrainerSearch: payload?.params?.isTrainerSearch,
        isTraineeSearch: payload?.params?.isTraineeSearch,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const getHomepageCategoriesRequest = () => ({ type: GET_HOMEPAGE_CATEGORIES_REQUEST });

export const getHomepageCategoriesSuccess = categories => ({
  type: GET_HOMEPAGE_CATEGORIES_SUCCESS,
  payload: categories,
});

export const getHomepageCategoriesError = e => ({
  type: GET_HOMEPAGE_CATEGORIES_ERROR,
  payload: e,
  error: true,
});

export const visitHomepageCategoriesRequest = () => ({ type: VISIT_HOMEPAGE_CATEGORIES_REQUEST });

export const visitHomepageCategoriesSuccess = () => ({
  type: VISIT_HOMEPAGE_CATEGORIES_SUCCESS,
});

export const visitHomepageCategoriesError = e => ({
  type: VISIT_HOMEPAGE_CATEGORIES_ERROR,
  payload: e,
  error: true,
});

export const searchListingsRequest = searchParams => ({
  type: SEARCH_LISTINGS_REQUEST,
  payload: { searchParams },
});

export const searchListingsSuccess = (response, params) => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data, params },
});

export const searchListingsError = e => ({
  type: SEARCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //


export const searchListings = (searchParams, config) => (dispatch, getState, sdk) => {
  dispatch(searchListingsRequest(searchParams));

  console.log(searchParams, 'searchParams')

  return sdk.listings
    .query(searchParams)
    .then(response => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      const specificSearchParams = {  };

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(searchListingsSuccess(response, specificSearchParams));

      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(searchListingsError(error));
      if (!(isErrorUserPendingApproval(error) || isForbiddenError(error))) {
        throw e;
      }
    });
};

